import { render, staticRenderFns } from "./component-mask-selector-quiz.vue?vue&type=template&id=aafe98d6&scoped=true&"
import script from "./component-mask-selector-quiz.vue?vue&type=script&lang=js&"
export * from "./component-mask-selector-quiz.vue?vue&type=script&lang=js&"
import style0 from "./component-mask-selector-quiz.vue?vue&type=style&index=0&id=aafe98d6&lang=scss&scoped=true&"
import style1 from "./component-mask-selector-quiz.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafe98d6",
  null
  
)

export default component.exports